// extracted by mini-css-extract-plugin
export default {"widths":"styles_widths__7nBVA","imageContainer":"styles_imageContainer__P+qtE"};